<template>
  <div class="view pa24">
    <div class="d-flex mb20">
      <div class="bgf7fa pt20 pr20 pl20 pb20 d-flex flex-column align-items-center mr20">
          <div class="d-flex align-items-center">
              <p class="fwbold fs10">{{ $t('finance', 'totalRevenue') }}</p>
              <el-tooltip
                class="item ml10"
                effect="dark"
                :content="$t('finance', 'totalRevenueTip')"
                placement="top"
              >
                <i style="font-size: 16px" class="el-icon-question" />
              </el-tooltip>
            </div>
          <p class="fwbold fs10">{{totalSells}}</p>
      </div>
      <div class="bgf7fa pt20 pr20 pl20 d-flex flex-column align-items-center mr20">
          <p class="fwbold fs10">{{ $t('finance', 'cumulativeProductIncome') }}</p>
          <p class="fwbold fs10">{{totalPrice}}</p>
      </div>
      <div class="bgf7fa pt20 pr20 pl20 d-flex flex-column align-items-center">
          <p class="fwbold fs10">{{ $t('finance', 'cumulativeCommissionExpense') }}</p>
          <p class="fwbold fs10">{{totalCommission}}</p>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <el-date-picker
        v-model="pickerValue"
        class="mr10 "
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        :start-placeholder="$t('finance', 'startDate')"
        :end-placeholder="$t('finance', 'endDate')"
      />
      <el-input class="mr20 w200"  v-model="keyword" :placeholder="$t('finance', 'companyNameOrPhone')"></el-input>
      <el-button type="primary" @click="queryVisitorsData">{{ $t('finance', 'query') }}</el-button>
      <!-- <el-button type="primary" @click="queryVisitorsData">导出</el-button> -->
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
            prop="companyId"
            align="center"
            :label="$t('finance', 'companyId')"
            show-overflow-tooltip
          />
        <el-table-column prop="companyName" align="center" :label="$t('finance', 'companyName')" />
        <el-table-column prop="nickName" align="center" :label="$t('finance', 'administrator')" />
        <el-table-column prop="phone" align="center" :label="$t('finance', 'administratorPhone')" />
        <el-table-column prop="totalPay" align="center" :label="$t('finance', 'totalPay')" />
        <el-table-column prop="commission" align="center" :label="$t('finance', 'commission')" />
        <el-table-column prop="balance" align="center" :label="$t('finance', 'remainingWithdrawableCommission')" />
        <el-table-column prop="visitTime" align="center" :label="$t('finance', 'operation')">
          <template slot-scope="scope">
            <p class="cblue hover_pointer" @click="toDetailPage(scope.row.companyId)">{{ $t('finance', 'details') }}</p>
          </template>
        </el-table-column>
        
      </template>
    </commonTable>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import {  
  bossSubordinationBalance
 } from "@/api/financing";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      sourcesId: "",
      authsId: "",
      phone: "",
      startTime: this.startTime,
      endTime: this.endTime,
      totalSells:0, //收入合计
      totalPrice:0, //累计商品收入
      totalCommission:0 ,//累计佣金
      keyword:''
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryVisitorsData();
  },
  methods: {
    async queryVisitorsData() {
      var patrn = /^(-)?\d+(\.\d+)?$/;
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        phone: '',
        companyName:'',
        startTime: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        endTime: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      
      if(this.keyword){
        if(patrn.exec(this.keyword)){
          data.phone = this.keyword
        }else{
          data.companyName = this.keyword
        }
      }
      try {
        this.loading = true;
        const result = await bossSubordinationBalance(data);
        this.loading = false;
        
        if (result?.data?.pageInfo) {
          const { total, list } = result.data.pageInfo;
          this.tableData = list || [];
          this.tableData.forEach(item=>{
            item.balance = (item.balance/100).toFixed(2)
            item.commission = (item.commission/100).toFixed(2)
            item.totalPay = (item.totalPay/100).toFixed(2)
          })
          this.total = total || 0;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        
        if (result?.data) {
          this.totalSells = result.data.totalSells ? (result.data.totalSells/100).toFixed(2) : '0.00';
          this.totalPrice = result.data.totalPrice ? (result.data.totalPrice/100).toFixed(2) : '0.00';
          this.totalCommission = result.data.totalCommission ? (result.data.totalCommission/100).toFixed(2) : '0.00';
        } else {
          this.totalSells = '0.00';
          this.totalPrice = '0.00';
          this.totalCommission = '0.00';
        }
      } catch (error) {
        this.tableData = [];
        this.loading = false;
        this.total = 0;
        this.totalSells = '0.00';
        this.totalPrice = '0.00';
        this.totalCommission = '0.00';
        console.log(error);
      }
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+this.$t('finance', 'second');
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+this.$t('finance', 'minute')+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+this.$t('finance', 'hour')+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVisitorsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVisitorsData();
    },
    toDetailPage(id){
      this.$router.push({ path:`/moneyForDetails?id=${id}` });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>